var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"notification-banner is-fullwidth",class:{
    'has-background-warning-light': _vm.isWarning,
    'has-text-warning-dark': _vm.isWarning,
    'has-background-info-light': _vm.isInfo,
    'has-text-info-dark': _vm.isInfo,
    'has-background-danger-light': _vm.isDanger,
    'has-text-danger-dark': _vm.isDanger
  }},[_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }